import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { OrganizationDetailsResponse } from "../../api-models/response/organization/OrganizationDetailsResponse";
import { UserResponse } from "../../api-models/response/user/UserResponse";

export class Organization {
  id: number;
  name: string;
  contact: OrganizationContactDetails;
  description: string;
  vat: string;
  countryCode: string;
  address: string;
  addressNumber: string;
  zip: string;
  city: string;
  state: string;
  hasPaidSubscription: boolean;
  created: Date;
  createdBy: NameEntityResponse;
  modified?: Date | null;
  modifiedBy?: NameEntityResponse;
  hasStripeCustomer: boolean;
  generalManagerFirstName: string;
  generalManagerLastName: string;
  phone: string;
  websiteURL?: string;

  constructor(response: OrganizationDetailsResponse) {
    this.id = response.id;
    this.name = response.name;
    this.description = response.description;
    this.vat = response.vat;
    this.countryCode = response.countryCode;
    this.address = response.address;
    this.addressNumber = response.addressNumber;
    this.zip = response.zip;
    this.city = response.city;
    this.state = response.state;
    this.hasPaidSubscription = response.hasPaidSubscription;
    this.created = response.created;
    this.createdBy = response.createdBy;
    this.modified = response.modified;
    this.contact = {
      userId: response.contact.id,
      name: response.contact.name,
      email: response.email,
    };
    this.phone = response.phone;
    this.hasStripeCustomer = response.hasStripeCustomer;
    this.generalManagerFirstName = response.generalManagerFirstName;
    this.generalManagerLastName = response.generalManagerLastName;
    this.websiteURL = response.websiteURL;
  }
}

export class OrganizationContactDetails {
  userId: number;
  name: string;
  email: string;

  constructor(userResponse: UserResponse) {
    this.userId = userResponse.id;
    this.name = userResponse.name;
    this.email = userResponse.email;
  }
}
